import { useQuery} from '@tanstack/react-query';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import {

  UseFetchEnabledParams,
} from '@/shared/interfaces';
import { getUrlParamsFetch } from '@/shared';
import { IBodegaProductoPagingRes } from '@/shared/interfaces/erp/inventario';

const { get} = erpApi();

///* tanSctack query
export const useFetchBodegaProducto = ({
  page = 1,
  page_size = 10,
  bodega = '',
}: GetBodegaProductoParams) => {
  return useQuery({
    queryKey: ['categoria-producto', page, bodega, page_size],
    queryFn: async () => {
      return getBodegaProductos({ page, bodega, page_size });
    },
  });
};

export const useFetchBodegaProductoEnabled = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<GetBodegaProductoParams>) => {
  return useQuery({
    queryKey: ['bodega_producto', params],
    queryFn: async () => {
      return getBodegaProductos(params);
    },
    enabled,
  });
};


///* axio
export type GetBodegaProductoParams = {
  page?: number;
  page_size?: number;
  bodega?: string;
};


export const getBodegaProductos = async (
  params?: GetBodegaProductoParams
) => {
  const queryParams = getUrlParamsFetch({ ...params });

  return get<IBodegaProductoPagingRes>(
    `${urlBackend}api/v1/bodega_producto/?${queryParams}`,
    true
  );
};

